module.exports = __webpack_public_path__ + "static/media/ktionic.5697a929.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/ktionic.png
// module id = 469
// module chunks = 3